import { WlWindow } from 'typings/globals/cordova';

declare const window: WlWindow;

export function enableSimpleKeyboard() {
  window?.Keyboard?.disableScroll?.(true);
  window?.Keyboard?.hideFormAccessoryBar?.(true);
}
export function enableLongFormKeyboard() {
  window?.Keyboard?.disableScroll?.(false);
  window?.Keyboard?.hideFormAccessoryBar?.(false);
}

export function resetKeyboard() {
  enableLongFormKeyboard();
}
